import React from 'react'
const LoginContext = React.createContext({ handleAfterLogin: null });

export default LoginContext
